import { useEffect, useState } from 'react'

import { API_URL } from '~config'

interface ActiveCallsEvent {
  type?: 'init' | 'update'
  active_call_count?: number
  updated_at?: string | null
}

// Streams the organization's in-progress AI call count. ``updateToken`` changes on
// every event (including transfers that leave the count unchanged) so open views
// can refetch call details.
export const useActiveCallCount = (
  organizationIdentityId: string | null,
  enabled: boolean,
): { activeCallCount: number; updateToken: number } => {
  const [activeCallCount, setActiveCallCount] = useState(0)
  const [updateToken, setUpdateToken] = useState(0)

  useEffect(() => {
    setActiveCallCount(0)
    if (!enabled || !organizationIdentityId) return undefined

    const url = `${API_URL}/ai/active-calls/stream/?organization_identity_id=${organizationIdentityId}`
    const eventSource = new EventSource(url, { withCredentials: true })

    eventSource.onmessage = (event): void => {
      try {
        const payload = JSON.parse(event.data) as ActiveCallsEvent
        if (typeof payload.active_call_count === 'number') {
          setActiveCallCount(payload.active_call_count)
        }
        setUpdateToken((token) => token + 1)
      } catch {
        return
      }
    }

    return (): void => {
      eventSource.close()
    }
  }, [organizationIdentityId, enabled])

  return { activeCallCount, updateToken }
}
